import React from 'react'
import { Button, Col, } from 'reactstrap'
import queryString from 'query-string'

export default function DeleteButtonSecondary({ id, search, history, styles }) {
  let qs = queryString.parse(search)
  qs.r = id
  qs.m = 'delete'
  const query = `?${queryString.stringify(qs)}`
  return (
    <span className="delete-button">
      <Button type="button" className={`btn btn-secondary`} style={styles} onClick={() => history.push(query)} >{"Delete"}</Button>
    </span>
  )
}   


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/DeleteButtonSecondary.js